import { useNodeState } from '../useNodeState';
import styles from './SelectModeCheckbox.module.scss';
import { CheckBox } from 'components/uikit/CheckBox';
import { useCallback, useSyncExternalStore } from 'react';
import { useSelectModeContext } from '../useSelectModeContext';

export const SelectModeCheckbox: React.FC<{ id: string }> = ({ id }) => {
  const { store, isSelectMode } = useSelectModeContext();
  const node = useNodeState(store, id);

  if (!node) return null;

  return (
    <div
      className={styles.checkboxContainer}
      onClick={(e) => {
        store.toggle(id);
        e.stopPropagation();
      }}
    >
      {isSelectMode && (
        <CheckBox
          checked={node.status === 'selected'}
          partial={node.status === 'partial'}
          readOnly
          className={styles.checkbox}
        />
      )}
    </div>
  );
};

export const HeaderSelectModeCheckbox: React.FC<{}> = () => {
  const { store, isSelectMode } = useSelectModeContext();

  const rootStatus = useSyncExternalStore(
    useCallback(
      (l) => {
        const unsubs = store.getRootIds().map((id) => store.subscribe(id, l));
        return () => unsubs.forEach((fn) => fn());
      },
      [store],
    ),
    useCallback(() => store.getRootStatus(), [store]),
  );

  return (
    <div className={styles.checkboxContainer} onClick={() => store.toggleAll()}>
      {isSelectMode && (
        <CheckBox
          checked={rootStatus === 'selected'}
          partial={rootStatus === 'partial'}
          readOnly
          className={styles.headerCheckbox}
        />
      )}
    </div>
  );
};
